var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9992 8.24994C13.373 8.24994 8 13.6438 8 20.2981C8 25.6201 11.438 30.1357 16.2072 31.7291C16.8073 31.8416 17.0262 31.4677 17.0262 31.1486L17.0097 29.0998C13.6715 29.8278 12.9672 27.4846 12.9672 27.4846C12.422 26.0934 11.6353 25.7227 11.6353 25.7227C10.5455 24.9749 11.7177 24.9901 11.7177 24.9901C12.9215 25.0753 13.5553 26.2318 13.5553 26.2318C14.6263 28.073 16.364 27.5413 17.048 27.2324C17.1567 26.4539 17.4672 25.9229 17.81 25.6199C15.1452 25.3158 12.344 24.2827 12.344 19.6663C12.344 18.3508 12.8113 17.2756 13.5793 16.433C13.4555 16.1281 13.0437 14.9038 13.6962 13.2449C13.6962 13.2449 14.7042 12.9211 16.9963 14.4798C17.954 14.2124 18.98 14.0793 20.0007 14.0739C21.02 14.0791 22.0468 14.2126 23.0052 14.4798C25.2957 12.9211 26.3015 13.2449 26.3015 13.2449C26.9563 14.9038 26.5445 16.1281 26.4207 16.433C27.1903 17.2756 27.6545 18.3508 27.6545 19.6663C27.6545 24.2938 24.8487 25.3128 22.1757 25.6109C22.6062 25.9829 22.9902 26.7178 22.9902 27.8422L22.9752 31.1471C22.9752 31.4696 23.1912 31.8446 23.8002 31.7261C28.565 30.1314 32 25.6188 32 20.2981C32 13.6438 26.627 8.24994 19.9992 8.24994Z",
    fill: "#3E75C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial2);
export default __webpack_public_path__ + "static/media/Social-2.0b9d706ce4805d021be3446b0490762d.svg";
export { ForwardRef as ReactComponent };